import { ConfigProvider, Form, Radio } from "antd";
import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { ruleRequired } from "../../../constants/rules/RulesConstantsForms";
import { RootState } from "../../../store/Store";
import { useAppDispatch, useAppSelector } from "../../../store/reduxHooks";
import { SELECT_USER_DATA } from "../../../store/selectors/authSliceLoginSelector";
import { MATCH_OFF_RENDERINGS } from "../../../store/slice/applicationCreateSlice/applicationCreateSlice";
import { USER } from "../../../types/indexTypeEnum";
import { InfoBlock } from "../../Ui/InfoBlock/InfoBlock";

import classes from "./innContainer.module.css";

/**
 * Компонент отображения организации при успешном инн при создании заявки.
 */
export function InnContainer(): ReactElement {
  const user = useAppSelector(SELECT_USER_DATA);

  const applicationCreateSlice = useSelector(
    (state: RootState) => state.applicationCreateSlice,
  );
  const { STAGE_INN_REQUEST } = applicationCreateSlice;

  const dispatch = useAppDispatch();

  const plainOptions = [
    { label: "Упрощенная", value: true },
    { label: "Общая", value: false },
  ];

  return (
    <ConfigProvider>
      <InfoBlock
        className={classes.innContainer__infoBlock}
        title={STAGE_INN_REQUEST?.data?.name || ""}
        description={`ИНН ${STAGE_INN_REQUEST?.data?.inn}`}
        isClosable={
          user?.type === USER.AGENT_SIMPLE || user?.type === USER.SUPPORT_CREDIT
        }
        onClose={() => {
          dispatch(
            MATCH_OFF_RENDERINGS({
              CONTAINER_INN: "NOT_DATA",
            }),
          );
        }}
      />
      <div
        className={classes.innContainer__fieldset}
        role="group"
        aria-labelledby="tax_system_legend"
      >
        <div
          id="tax_system_legend"
          className={classes.innContainer__radioLegend}
        >
          Система налогообложения
        </div>
        <Form.Item
          name="is_tax_simple"
          noStyle={true}
          required={true}
          rules={[ruleRequired]}
        >
          <Radio.Group
            className={classes.radioGroup}
            options={plainOptions}
            optionType="button"
            buttonStyle="solid"
          />
        </Form.Item>
      </div>
    </ConfigProvider>
  );
}
